import { createSelector } from "reselect";
import { AppState } from "app/shared/store/root.reducer";

const getStore = (state: AppState) => state.billing;
const getResponseMakeFee = (state: AppState) => state.billing.responseMakeFee;
const getResponsePackage = (state: AppState) => state.billing.responsePackage;
const getResponseInfo = (state: AppState) => state.billing.responseInfo;
const getBillingInfoPending = (state: AppState) => state.billing.pendingInfo;
const getBillingPackagePending = (state: AppState) => state.billing.pendingPackage;
const getResCustomerInfo = (state: AppState) => state.billing.customerInfo;
const getDataCreate = (state: AppState) => state.billing.dataCreate;
const getResponseCreated = (state: AppState) => state.billing.responseCreate;
const getResponseConfirm = (state: AppState) => state.billing.responseConfirm;
const getResponseAuth = (state: AppState) => state.billing.responseAuth;
const getBillingCustomerIsChecked = (state: AppState) => state.billing.isCheckedCustomer;

export const getBillingStoreSelector = createSelector(getStore, (data) => data);
export const getBillingInfoSelector = createSelector(getResponseInfo, (info) => info);
export const getBillingInfoPendingSelector = createSelector(getBillingInfoPending, (status) => status);
export const getBillingMakeFeeSelector = createSelector(getResponseMakeFee, (fee) => fee);
export const getBillingPackageSelector = createSelector(getResponsePackage, (data) => data);
export const getBillingPackagePendingSelector = createSelector(getBillingPackagePending, (status) => status);

export const getBillingResCustomerInfoSelector = createSelector(getResCustomerInfo, (customer) => customer);
export const getBillingDataCreateSelector = createSelector(getDataCreate, (data) => data);

export const getBillingResponseCreatedSelector = createSelector(getResponseCreated, (res) => res);

export const getBillingResponseConfirmSelector = createSelector(getResponseConfirm, (res) => res);

export const getBillingResponseAuthSelector = createSelector(getResponseAuth, (res) => res);

export const getBillingCustomerIsCheckedSelector = createSelector(getBillingCustomerIsChecked, (status) => status);
